import React from "react";

function Location() {
  try {
    return (
      <section
        className="section-padding bg-white px-4 sm:px-6 lg:px-8"
        data-name="location"
        data-file="components/Location.js"
      >
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-6">
              Location & Directions
            </h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              Angelo's Farm is conveniently located in Kukas, Jaipur, offering
              easy access to the city's attractions while providing a peaceful
              retreat.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Map */}
            <div className="bg-stone-100 rounded-2xl overflow-hidden shadow-lg border-2 border-[#B86A4B]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.1234567890!2d75.7!3d26.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDU0JzAwLjAiTiA3NcKwNDInMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Angelo's Farm Location"
              ></iframe>
            </div>

            {/* Location Details */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-serif font-bold text-stone-800 mb-4">
                  Address
                </h3>
                <div className="flex items-start space-x-3">
                  <div
                    className="icon-map-pin text-xl"
                    style={{ color: "#B86A4B" }}
                  ></div>
                  <div>
                    <p className="text-lg text-stone-700">Angelo's Farm</p>
                    <p className="text-stone-600">Kukas, Jaipur, Rajasthan</p>
                    <p className="text-stone-600">India</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-serif font-bold text-stone-800 mb-4">
                  How to Reach
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="icon-car text-xl text-orange-700 mt-1"></div>
                    <div>
                      <p className="font-semibold text-stone-700">By Car</p>
                      <p className="text-stone-600">
                        30 minutes from Jaipur city center
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3">
                    <div className="icon-plane text-xl text-orange-700 mt-1"></div>
                    <div>
                      <p className="font-semibold text-stone-700">
                        From Airport
                      </p>
                      <p className="text-stone-600">
                        45 minutes from Jaipur International Airport
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-3">
                    <div className="icon-train text-xl text-orange-700 mt-1"></div>
                    <div>
                      <p className="font-semibold text-stone-700">
                        From Railway Station
                      </p>
                      <p className="text-stone-600">
                        40 minutes from Jaipur Junction
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-serif font-bold text-stone-800 mb-4">
                  Nearby Attractions
                </h3>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-stone-700">Amber Fort</span>
                    <span className="text-stone-500">15 km</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-stone-700">City Palace</span>
                    <span className="text-stone-500">25 km</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-stone-700">Hawa Mahal</span>
                    <span className="text-stone-500">28 km</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-stone-700">Jantar Mantar</span>
                    <span className="text-stone-500">26 km</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } catch (error) {
    console.error("Location component error:", error);
    return null;
  }
}

export default Location;
